import React, { useEffect } from 'react';
import { onBlankLayout, onBrandStoreLayout, onCatalogLayout } from 'store/slices/themeSlice';
import { useDispatch } from 'react-redux';

const AppRoute = ({ component: Component, routeKey, blankLayout, isBrandStore, isCatalog, ...props }) => {

	const dispatch = useDispatch()

	useEffect(() => {
		const isBlank = blankLayout ? true : false
		const isBrandStoreActive = isBrandStore ? true : false
		const isCatalogActive = isCatalog ? true : false

		dispatch(onBlankLayout(isBlank))
		dispatch(onBrandStoreLayout(isBrandStoreActive))
		dispatch(onCatalogLayout(isCatalogActive))

	}, [blankLayout, isBrandStore, isCatalog, dispatch])

	return (
		<Component {...props} />
	)
}

export default AppRoute